import React from 'react';
import { Building2, Award, Globe2, Users, Clock, Stethoscope, Activity, Zap, Timer, Shield, Guitar as Hospital, HeartPulse } from 'lucide-react';
import './Ts41.css';

const Ts41: React.FC = () => {
  return (
    <div className="ts41">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Heavy Ion Therapy</h1>
          <p>Advanced Cancer Treatment at Taipei Veterans General Hospital</p>
        </div>
      </div>

      {/* Introduction Section */}
      <section className="intro-section container">
        <div className="intro-content">
          <div className="intro-text">
            <h2>Understanding Cancer's Global Impact</h2>
            <p>
              Cancer remains one of the world's most significant health challenges, claiming 7.6 million 
              lives annually. In Taiwan, it has been the leading cause of death for over three decades, 
              highlighting the critical need for advanced treatment solutions.
            </p>
          </div>
          <div className="intro-image">
            <img 
              src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&q=80&w=2000" 
              alt="Medical Technology"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Hospital Overview */}
      <section className="hospital-section container">
        <div className="section-header">
          <h2>Taipei Veterans General Hospital Excellence</h2>
        </div>
        <div className="achievements-grid">
          <div className="achievement-card">
            <Hospital className="card-icon" />
            <h3>Established Legacy</h3>
            <p>Founded in 1958 with a dedicated focus on pioneering cancer treatment and research.</p>
          </div>
          <div className="achievement-card">
            <Award className="card-icon" />
            <h3>Global Recognition</h3>
            <p>Designated as a Center of Excellence for Cancer Research and National Clinical Trial Center.</p>
          </div>
          <div className="achievement-card">
            <HeartPulse className="card-icon" />
            <h3>Specialized Focus</h3>
            <p>Leading research in oral, breast, liver, and lung cancer treatments.</p>
          </div>
        </div>
      </section>

      {/* Treatment Technology */}
      <section className="treatment-section container">
        <div className="section-header">
          <h2>Heavy Ion Therapy Technology</h2>
        </div>
        <div className="treatment-content">
          <div className="treatment-info">
            <h3>How It Works</h3>
            <p>
              Carbon atoms are extracted from methane (CH₄) and accelerated to 70% of the speed of light, 
              delivering precise treatment to tumors while minimizing damage to surrounding tissue through 
              the Bragg Peak effect.
            </p>
          </div>
          <div className="advantages-grid">
            <div className="advantage-card">
              <Zap className="card-icon" />
              <h3>Superior Effectiveness</h3>
              <p>Carbon ions are 12 times heavier than protons and 3 times more effective in killing tumor cells.</p>
            </div>
            <div className="advantage-card">
              <Shield className="card-icon" />
              <h3>Overcomes Resistance</h3>
              <p>Effective against tumors in low-oxygen environments that typically resist conventional therapy.</p>
            </div>
            <div className="advantage-card">
              <Timer className="card-icon" />
              <h3>Shorter Treatment</h3>
              <p>Only 12 or fewer sessions needed compared to 30+ with traditional therapies.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Center */}
      <section className="tech-center-section container">
        <div className="section-header">
          <h2>Taiwan's First Heavy Ion Therapy Center</h2>
        </div>
        <div className="tech-features">
          <div className="tech-image">
            <img 
              src="https://images.unsplash.com/photo-1516549655169-df83a0774514?auto=format&fit=crop&q=80&w=2000" 
              alt="Advanced Medical Technology"
              loading="lazy"
            />
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <Activity className="card-icon" />
              <h3>State-of-the-Art Technology</h3>
              <p>Advanced pencil beam scanning technology for high-precision tumor targeting.</p>
            </div>
            <div className="feature-card">
              <Globe2 className="card-icon" />
              <h3>Japanese Partnership</h3>
              <p>Utilizing cutting-edge equipment imported from Japan's leading medical technology providers.</p>
            </div>
            <div className="feature-card">
              <Shield className="card-icon" />
              <h3>Maximum Safety</h3>
              <p>Comprehensive radiation shielding and real-time tumor tracking for optimal treatment safety.</p>
            </div>
            <div className="feature-card">
              <Users className="card-icon" />
              <h3>Patient-Centered Care</h3>
              <p>Focused on both physical and mental well-being with professional medical support.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Ts41;